<template>
  <a-modal
      title="重置密码"
      :width="500"
      :visible="visible"
      :confirmLoading="false"
      :maskClosable="false"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="adminForm" :model="form" :label-col="{span: 6}" :wrapper-col="{span: 15}">
        <a-form-model-item v-show="false" label="id" prop="id"
          :rules="[{ required: true, message: '必填，不能为空' }]">
          <a-input v-model.number="form.id" type="hidden" />
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="password"
          :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
          <a-input v-model="form.password" type="password" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      form: {
        id: 0,
        password: ''
      }
    }
  },
  watch: {
    id: {
      handler(val) {
        this.form.id = val || 0;
      },
      immediate: true
    },
    visible(val) {
      if (val) {
        this.form.password = '';
        this.$nextTick(() => {
          if (this.$refs.adminForm) {
            this.$refs.adminForm.clearValidate();
          }
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
